import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ChatTongole from './components/Chat/ChatTongole';
import FloatingWhatsapp from './components/common/FloatingWhatsapp';
import DownloadNotice from './common/downloadNotice';

// Set data-origin on <html> for origin-scoped styling
const originForAttr = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '')
  .replace(/(\.com|\.live|\.net|\.world)$/i, '');
document.documentElement.setAttribute('data-origin', originForAttr);

const container = document.getElementById('root');
const root = createRoot(container);

// Register service worker for offline caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        // Service worker registered successfully
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available - could show update prompt here
              }
            });
          }
        });
      })
      .catch(() => {
        // Service worker registration failed - app still works without it
      });
  });
}

root.render(
  <BrowserRouter>
    <DownloadNotice />
    <FloatingWhatsapp side="right" offsetBottom={200} />
    <ChatTongole />
    <App />
  </BrowserRouter>
);